import React, { useState } from 'react';
import { events } from '../data/events';
import { ExternalLink, Calendar, MapPin } from 'lucide-react';
import './Events.css';

const years = Object.keys(events).sort((a, b) => b - a);

function Events() {
  const [activeYear, setActiveYear] = useState(null);
  const displayYears = activeYear ? [activeYear] : years;

  return (
    <div className="events-page">
      <div className="container">
        <section className="page-hero">
          <h1>Events</h1>
          <p className="subtitle">
            Conferences, workshops, and meetings attended by members of our group.
          </p>
        </section>

        {/* Year filter */}
        <div className="year-pills" style={{ marginBottom: '2.5rem' }}>
          <button
            className={`year-pill ${activeYear === null ? 'active' : ''}`}
            onClick={() => setActiveYear(null)}
          >
            All
          </button>
          {years.map(y => (
            <button
              key={y}
              className={`year-pill ${activeYear === y ? 'active' : ''}`}
              onClick={() => setActiveYear(activeYear === y ? null : y)}
            >
              {y}
            </button>
          ))}
        </div>

        {/* Events timeline */}
        <div className="events-timeline">
          {displayYears.map(year => (
            <div className="events-year-group" key={year}>
              <div className="events-year-label">{year}</div>
              <div className="events-items">
                {events[year].map((event, i) => (
                  <div className="event-row" key={i}>
                    <div className="event-date">
                      <Calendar size={14} />
                      <span>{event.date}</span>
                    </div>
                    <div className="event-info">
                      <h3 className="event-name">{event.name}</h3>
                      <div className="event-location">
                        <MapPin size={13} />
                        <span>{event.location}</span>
                      </div>
                    </div>
                    {event.link && (
                      <a
                        href={event.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="event-link-btn"
                      >
                        Details <ExternalLink size={13} />
                      </a>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Events;
